export default __webpack_public_path__ + "static/media/dotnet-svgrepo-com.ef417244.svg";